<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    
    <a class="logo" href="#" (click)="navigateHome()">{{appName}}</a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action" icon="color-palette-outline" [nbContextMenu]="themeMenu"></nb-action>
    <nb-action class="user-action" icon="text-outline" [nbContextMenu]="languages" >
    </nb-action>
  </nb-actions>

  <nb-actions size="small">
    <nb-action class="control-item" icon="email-outline" (click)="openWithEscClose()"></nb-action>
    <!-- <nb-action class="control-item" icon="bell-outline"></nb-action> -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="user?.name" [picture]="user?.picture"
        [link]="user?.url">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
